import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';
import { useModulePackage } from '@platform/modularity/useModulePackage';
import { CustomizeModuleBody } from './CustomizeModuleBody';
import type { ICustomizeModulePageProps } from './ICustomizeModulePageProps';
import { SettingsLoadingPage } from './settings/SettingsLoadingPage';
import { useCustomizeReads } from './settings/useCustomizeReads';
import './settings/settings.css';

/**
 * /customize/forms/:module і /customize/modules/:module — редактор форми й «Записи й форми» модуля всередині розділу
 * «Налаштування» (прототип v4 cust-form / cust-module без inMod: меню «Налаштування» з активними «Форми» / «Встановлені модулі», верхня
 * панель у режимі Налаштувань — їх дає оболонка за адресою /customize). Ключ модуля — сегмент `:item`; пакет модуля (рядки, представлення)
 * вантажиться тут, як межа пакета на маршрутах модуля (ModulePackageBoundary); невдале завантаження — узагальнений рушій. Читання сторінки
 * (визначення, перевизначення типу форми, перший запис) стартують одразу, разом із читанням каталогу оболонки (useCustomizeReads), а
 * поки пакет вантажиться, видно крихти, повернення й заголовок (SettingsLoadingPage) — сторінка не буває порожньою (рішення 3 етапу 11).
 */
export function CustomizeModulePage({ section, global = false }: ICustomizeModulePageProps) {
  const { ws, item = '' } = useWorkspaceParams();
  const pkg = useModulePackage(item);
  const definition = useCustomizeReads(ws, item, section, global);
  if (pkg.status === 'loading') return <SettingsLoadingPage ws={ws} moduleKey={item} section={section} global={global} definition={definition} />;
  return <CustomizeModuleBody key={`${section}/${item}`} ws={ws} moduleKey={item} section={section} global={global} />;
}
